/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Firstsubjectgraduation2Inputs */

const de__field_firstsubjectgraduation2 = /** @type {(inputs: _Field_Firstsubjectgraduation2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abschluss Erstfach`)
};

/**

* @param {_Field_Firstsubjectgraduation2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_firstsubjectgraduation2 = /** @type {((inputs?: _Field_Firstsubjectgraduation2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Firstsubjectgraduation2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_firstsubjectgraduation2(inputs)
});
export { _field_firstsubjectgraduation2 as "_field_firstSubjectGraduation" }